<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <div >
        <mat-form-field appearance="outline">
          <mat-label >Email</mat-label>
          <input matInput [(ngModel)]="onlinePaymentsObj.email "/>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label >Bank name</mat-label>
          <input matInput [(ngModel)]="onlinePaymentsObj.bank_name "/>
          <!--  -->
        </mat-form-field>
      </div>
    <div >
        <mat-form-field appearance="outline">
          <mat-label >Account holder name</mat-label>
          <input matInput [(ngModel)]="onlinePaymentsObj.account_holder_name "/>
          <!--  -->
        </mat-form-field>
      </div>
    <div >
        <mat-form-field appearance="outline">
          <mat-label >Branch name</mat-label>
          <input matInput [(ngModel)]="onlinePaymentsObj.branch_name "/>
          <!--  -->
        </mat-form-field>
      </div>
    <div class="radio_group">
        <label>Account type: </label>
        <mat-radio-group [(ngModel)]="onlinePaymentsObj.accountType">
          <mat-radio-button [value]="0">Savings</mat-radio-button>
          <mat-radio-button [value]="1">Current</mat-radio-button>
        </mat-radio-group>
      </div>
     
      <div >
        <mat-form-field appearance="outline">
          <mat-label>Account number</mat-label>
          <input smNumericOnly matInput [(ngModel)]="onlinePaymentsObj.account_number "/>
          <!--  -->
        </mat-form-field>
      </div>
      <div >
        <mat-form-field appearance="outline">
          <mat-label>IFSC code</mat-label>
          <input matInput [(ngModel)]="onlinePaymentsObj.ifsc_code "/>
          <!--  -->
        </mat-form-field>
      </div>
      <div >
        <mat-form-field appearance="outline">
          <mat-label>PAN card number</mat-label>
          <input matInput [(ngModel)]="onlinePaymentsObj.pan_card_number "/>
          <!--  -->
        </mat-form-field>
      </div>
      <div class="radio_group">
        <label>Refund period: </label>
        <mat-radio-group [(ngModel)]="onlinePaymentsObj.refund_period">
          <mat-radio-button [value]="5">5 days</mat-radio-button>
          <mat-radio-button [value]="10">10 days</mat-radio-button>
          <mat-radio-button [value]="15">15 days</mat-radio-button>
        </mat-radio-group>
      </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      (click)="onSubmitDiscountDetails()"
      [disabled]="
      !onlinePaymentsObj.bank_name ||
      !onlinePaymentsObj.account_number ||
      !onlinePaymentsObj.ifsc_code ||
      !onlinePaymentsObj.account_holder_name 
      "
    >
      Confirm
    </button>
  </mat-dialog-actions>